import classNames from 'classnames';
import React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';

import './clear-refinements.scss';

const clearRefinements = ({ items, refine }) => (
  <div
    className={classNames({
      clearFilterBox: true,
      active: items.length,
    })}
    onClick={() => refine(items)}
  >
    <i className="fas fa-times-circle"></i>
    <span className="newClearFilters flex-filters">Clear Filters</span>
  </div>
);

const ClearRefinements = connectCurrentRefinements(clearRefinements);

export default ClearRefinements;